import Cookies from 'js-cookie';

export function initCookieBar()
{
	const acceptCookies = document.getElementById('acceptCookies');

	if (typeof acceptCookies != 'undefined' && acceptCookies != null)
	{
		acceptCookies.addEventListener('click', function () {
			document.querySelector('.cookie-bar').classList.add('agreed');
			Cookies.set('cookie_consent', '1', { expires: 365*3 });
		});
	}
}
